import React from 'react';
import { useInView } from 'react-intersection-observer';

type IntersectionProps = {
    root?: Element | null | undefined;
    rootMargin?: string;
    threshold?: number | number[];
    trackVisibility?: boolean;
    delay?: number;
    triggerOnce?: boolean;
    initialInView?: boolean;
    fallbackInView?: boolean;
};

type Props = {
    child: React.JSX.Element | React.ReactNode;
    intersectionProps?: IntersectionProps;
};

const intersectionDefaults: IntersectionProps = {
    root: null,
    rootMargin: '200px',
    threshold: 0,
    trackVisibility: false,
    delay: 0,
    triggerOnce: false,
    initialInView: false,
    fallbackInView: false,
};

export function LazyLoadComponent({ child, intersectionProps }: Props): React.JSX.Element | null {
    const overwriteOptions = { ...intersectionProps };
    if (intersectionProps && intersectionProps.trackVisibility) {
        if (!intersectionProps.delay || intersectionProps.delay < 100) {
            overwriteOptions.delay = 100;
            console.warn(
                'The IntersectionObserver parameter "trackVisibility" requires "delay" to be set to a minimum of 100(ms)'
            );
            // https://w3c.github.io/IntersectionObserver/v2/#dom-intersectionobserver-intersectionobserver
        }
    }

    const [ref, inView] = useInView({
        ...intersectionDefaults,
        ...overwriteOptions,
    });
    return inView ? <span>{child}</span> : <div ref={ref} />;
}
